// extracted by mini-css-extract-plugin
export default {"loadingContainer":"YpCz6","spinner":"_Zzi5","spin":"lEIHZ","loadingText":"AkAvD"};